
import { POIType, poi_types } from './poi_helpers';
import my_location_icon from '../markers/marker_my_location.svg';
import bed_icon from '../markers/marker_bed.svg';
import map_marker_icon from '../markers/marker_map_marker.svg';
import shopping_cart_icon from '../markers/marker_shopping.svg';
import utensils_icon from '../markers/marker_restaurant.svg';
import bus_stop_icon from '../markers/marker_bus_stop.svg';
import empty from '../markers/marker_empty.svg';
import vl_icon from '../markers/marker_vl.svg';
import region_icon from '../markers/marker_region_vastmanland.svg';


let icons = {
    point: map_marker_icon,
    commerce: shopping_cart_icon,
    hotel: bed_icon,
    bus_stop: bus_stop_icon,
    food: utensils_icon,
    my_location: my_location_icon,
    text: empty,
    region: region_icon,
    vl: vl_icon
};

export function getIconByPOIType(type: POIType): google.maps.Icon {
    if (poi_types.includes(type) === false || icons.hasOwnProperty(type) === false) {
        //TODO: Silent slack msg.
        console.error("Uknown poi_type for icon.");
        return {
            url: map_marker_icon
        };
    }

    return {
        url: icons[type],
        labelOrigin: new window.google.maps.Point(25, 60)
    };
}



// WEBPACK FOOTER //
// ./src/helpers/icon_helpers.ts